 // Reusable helper
export const verifyPin = () => {
  const pin = window.prompt("Enter PIN to confirm deletion:");
  if (pin === null) {
    return false; // User cancelled
  }
  if (pin !== "2025") {
    window.alert("Incorrect PIN. Deletion cancelled.");
    return false;
  }
  return true; // PIN correct
};


export const formatPhoneNumber = (phone) => {
  // Check if phone is null, undefined, or empty
  if (!phone || phone.toString().trim() === '') {
    return null;
  }

  // Convert to string, remove all spaces and non-digit characters except +
  let cleanPhone = phone.toString().trim();
  
  // Remove + sign if present
  cleanPhone = cleanPhone.replace(/\+/g, '');
  
  // Remove all spaces and non-digit characters
  cleanPhone = cleanPhone.replace(/\D/g, '');

  // Check if empty after cleaning
  if (!cleanPhone) {
    return null;
  }

  // Handle Indian numbers specifically
  if (cleanPhone.length === 10) {
    // 10 digit number - add 91 prefix for India
    return '91' + cleanPhone;
  } else if (cleanPhone.length === 11 && cleanPhone.startsWith('0')) {
    // 11 digit number starting with 0 - remove 0 and add 91
    return '91' + cleanPhone.substring(1);
  } else if (cleanPhone.length === 12 && cleanPhone.startsWith('91')) {
    // 12 digit number starting with 91 - keep as is
    return cleanPhone;
  } else if (cleanPhone.length === 13 && cleanPhone.startsWith('091')) {
    // 13 digit number starting with 091 - remove 0
    return cleanPhone.substring(1);
  } else {
    // For other international numbers, return as is
    return cleanPhone;
  }
};